module.exports = {
      id: "astrology-usage",
      viewBox: "0 0 29.4 29.4",
      url: "/" + "sprite-6d93c42890617d6f6477c703e3b36dd9.svg#astrology",
      toString: function () {
        return this.url;
      }
    }